/**
 * Surah anchors let a link open a Quran page already scrolled to the surah that
 * was selected, instead of the top of the page. A page can hold several surahs
 * (e.g. page 599 starts with Zilzal and continues with Âdiyât), so the page
 * number alone is not enough.
 */

const SURAH_ANCHOR_PREFIX = 'sure-'

/** Returns the DOM id placed on a surah's header inside the Quran reader. */
export const getSurahAnchorId = (surahNumber: number): string =>
  `${SURAH_ANCHOR_PREFIX}${surahNumber}`

/** Returns the Quran page link that opens scrolled to the given surah. */
export const getSurahPageHref = (surah: { page: number; index?: number }): string => {
  const pageHref = `/kuran/${surah.page}`
  if (!surah.index) return pageHref
  return `${pageHref}#${getSurahAnchorId(surah.index)}`
}
